
<template>
  <div class="input-box">
    <input type="text" class="input-btn" name="" @click="popInput" :placeholder="getDict(51)">
    <portal to="modalPortal" v-if="ifOpenInput">
      <div class="input-page" @click="closeInput" v-scroll-stop>
        <div class="top-block"  @click.stop>
          <input ref="inputElent" class="input" type="" name="" :placeholder="` ${getDict(51)}`" v-model="text">

          <div class="ni-ming-box">
            <div class="select-input" @click="anonymous = !anonymous">
              <i v-if="anonymous" class="icon icon-selected-black"></i>
            </div>
            <span class="ni-ming">{{getDict(53)}}</span>
          </div>
          <button 
            class="submit" 
            :class="waitTime?'wait':''" 
            type="button" 
            :disabled="!!waitTime"
            @click="submit"
          >{{getDict(54) | formatDict(waitTime?`(${waitTime}s)`:'')}}</button>
        </div>
        
      </div>
      
    </portal>
  </div>
  
</template>

<script>

  import { bus, getDict, axios } from '../common'
  

  export default {
    props: {
    },
    data(){
      return {
        text:'',
        ifOpenInput:false,
        anonymous:false,
        waitTime:0,
      }
    },
    watch:{
    },
    methods: {
      getDict,
      popInput(){
        this.ifOpenInput = true;
        this.$nextTick(()=>{
          this.$refs.inputElent.focus();
        })
        
      },
      closeInput(){
        this.ifOpenInput = false;
        this.$refs.inputElent.blur();
      },
      timeRun(){
        if(this.waitTime){
          this.waitTime --;
          setTimeout(()=>{
            this.timeRun();
          },1000)
        }
      },
      submit(){
        /*this.waitTime = 5;
        this.timeRun();*/
        this.$emit('submit',{
          text:this.text,
          anonymous:this.anonymous
        });
        this.text = '';
        this.closeInput();
      }
    },
    mounted(){
    },
    created(){
      
    },
    beforeDestroy(){
    }
  }
</script>

<style lang="scss" scoped>
  .input-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    .input-btn{
      height: 0.35rem;
      padding: 0;
      border: 0;
      font-size:  0.2rem;
      color: #fff;
      background:#000;
      border: 1px solid #3d3d3d;
      padding-left: 0.07rem;
    }

    
  }

  .input-page{
    z-index: 10;
    position: fixed;
    width:100%;
    height: 100%;
    bottom: 0;
    background-color: rgba(0,0,0,0.7);

    .top-block{
      background-color: rgba(0,0,0,1);
      height: 1rem;
      padding-left: 1.5rem;
      display: flex;
      align-items: center;
      $font-size: 0.3rem;
      font-size:$font-size;
      

      .input{
        background-color: rgba(255,255,255,0.2);
        border: 0;
        color: #ffc952;
        
        line-height: $font-size *2;
        border-radius: $font-size *2;
        padding:0 #{$font-size * 1};
        flex:1;
        

      }
      .ni-ming-box{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 0.5rem;
        color: #ffc952;
        .select-input{
          background-color: #fff;
          width: 0.3rem;
          height: 0.3rem;
          border-radius: 0.05rem;
          padding: 0.05rem 0;
          display: flex;
          align-items: center;
          justify-content: center;
          .icon{
            margin: 0;
          }
        }
        .ni-ming{
          display: inline-block;
          margin-left: 0.1rem;
          padding-bottom: 0.02rem;
        }
      }

      .submit{
        background-color: #ffc952;
        color: #fff;
        min-width: 1.5rem;
        padding: 0.05rem 0.1rem 0.07rem;
        border-radius: 0.05rem;
        text-align: center;
        margin: 0 0.6rem;

        &.wait{
          background-color: #a0a7b4;
          color: #444444;
        }
      }
      
    }
  }

  
</style>
